module.exports = __webpack_public_path__ + "res/roboto-v15-latin-700.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-700.woff2
// module id = 104
// module chunks = 1